import { Icon, type IconProps } from '@customerio/pluma-components/react';
import type { PushPlatform } from '../types';
import * as styles from '../styles.css';

export type PlatformIconProps = {
  platform: PushPlatform;
  /**
   * Names the mark for assistive technology. Pass one only where the mark is the
   * only thing saying which platform this is; alongside the platform in text it
   * would be read out twice, so by default the mark is decorative.
   */
  label?: string;
} & Omit<IconProps, 'name' | 'label' | 'className'>;

/** The platform's own mark, in its brand colour. */
export function PlatformIcon({ platform, label, ...boxProps }: PlatformIconProps) {
  const isIos = platform === 'ios';

  return (
    <Icon
      name={isIos ? 'apple' : 'android'}
      label={label}
      aria-hidden={label == null ? true : undefined}
      display="block"
      // The mark must keep its intrinsic size in any row it sits in.
      flexShrink="0"
      {...boxProps}
      className={isIos ? styles.appleIcon : styles.androidIcon}
    />
  );
}
